export default class BaseObject {
  Clone() {
    return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
  }
}
